import { useNavigate } from "react-router-dom";

import { IColumnProps } from "../../../interfaces/tables";
import { EtyStudent } from "../../../interfaces/entities";

import { SVGIcon } from "../../wrappers/SVGIcon";
// import { Checkbox } from "../../reusables/FormElements";

import { Icons } from "../../../data/Assets";

interface StudentListTableProps {
  students: EtyStudent[];
  selectedStudents: number[];
  onStudentSelect: (studentId: number) => void;
  isLoading: boolean;
};
const StudentListTable = (props: StudentListTableProps) => {
  const { students, isLoading } = props;

  const navigate = useNavigate();

  const columns: IColumnProps[] = [
    // { name: "", identifier: "checkbox", },
    { name: "Applicant Name", identifier: "applicant_name" },
    { name: "Phone Number", identifier: "phone" },
    { name: "Edu Email", identifier: "edu_email" },
    { name: "Personal Email", identifier: "personal_email" },
    { name: "Linked", identifier: "linked" },
  ];

  const getLinkedIcon = (item: EtyStudent) => {
    if (item.date_linked) {
      return <SVGIcon src={Icons.CheckCircleFill} color='success' />
    } else if (item.date_unlinked) {
      return <SVGIcon src={Icons.ExclamationCircleFill} color='grey' />
    }
    return "N/A";
  };

  return (
    <div className="immersion__list_table__container">
      <table className="immersion__list_table">
        <thead>
          <tr>
            {columns.map((column, index) =>
              <th key={column.identifier}>
                <div className={`display_flex ${index === 4 ? 'display_flex_center' : ''}`}>
                  <button className={`${column.buttonClass ?? ''}`}>
                    {column.name}
                    {column?.sort && <SVGIcon src={Icons.ArrowDownUp} color='primary' />}
                  </button>
                </div>
              </th>
            )}
          </tr>
        </thead>
        <tbody>
          {isLoading &&
            <tr>
              <td colSpan={columns.length}>
                <div className="display_flex flex_dir_column display_flex_center">
                  <span className="wt_600 pb_10">Loading</span>
                  <i className='immersion__list_loader' />
                </div>
              </td>
            </tr>
          }
          {!isLoading && !students.length &&
            <tr>
              <td colSpan={columns.length} className='text_center'>
                No records found.
              </td>
            </tr>
          }
          {
            !isLoading && !!students.length &&
            students.map((item) => {
              return (
                <tr
                  key={item.id}
                  onClick={() => navigate(`/students/${item.id}/personal`)}
                >
                  {/* <td>
                  <Checkbox
                    name=""
                    label=""
                    checked={isChecked(item.id)}
                    onChange={() => onStudentSelect(item.id)}
                  />
                </td> */}
                  <td>{item.first_name}&nbsp;{item.last_name}</td>
                  <td>{item.phone ?? "-"}</td>
                  <td className="immersion__color__dark_grey">{item.edu_email ?? "-"}</td>
                  <td>{item.personal_email ?? "-"}</td>
                  <td>
                    <div className="display_flex display_flex_center">
                      {getLinkedIcon(item)}
                    </div>
                  </td>
                </tr>
              )
            })
          }
        </tbody>
      </table>
    </div>
  );
};

export default StudentListTable;
